<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    :scrollable="false"
    icon="fa-cube"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="resourceForm" :labelColumnSize="3">
      <FormRow label="Name">
        <FormInputText v-model="resourceData.name" field="name" />
      </FormRow>
      <FormRow label="Type">
        <FormSelect v-model="resourceData.type" field="type" :options="ResourceTypeLookup" />
      </FormRow>
      <FormRow label="User" v-show="isUserType">
        <UserSearchableSelect v-model="resourceData.userId" field="userId" />
      </FormRow>
      <FormRow label="Operating UOM Type">
        <FormSelect v-model="resourceData.operatingUOMType" field="operatingUOMType" :options="stockUOMTypeOptions" note="Unit of Measure used for cost / performance analytics" />
      </FormRow>
      <FormRow label="Operating Cost / Unit">
        <FormInputCurrency v-model="resourceData.operatingCostPerUnit" field="operatingCostPerUnit" />
      </FormRow>
      <FormRow label="Highlight Colour" helpTip="Highlight colour for the resource used in the calendar and maps for task management">
        <FormColourTag v-model="resourceData.highlightColour" field="highlightColour" />
      </FormRow>

      <FormHorizontalRule />
      <FormRow label="Resource Groups">
        <FormMultiSelect v-model="resourceData.resourceGroups" field="resourceGroups" :options="resourceGroupList" :loading="resourceGroupLoading" placeholder="Select Resource Groups" note="A resource can be associated with one or more groups" />
      </FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import UserSearchableSelect from '@/modules/users/components/userSearchableSelect'

import { UOMTypes, UOMTypeLookup, ResourceTypes, ResourceTypeLookup } from '@/store/types'

export default {
  name: 'ResourceDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    UserSearchableSelect
  },
  props: {
    resourceGroupId: Number,
    resourceId: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      resourceData: {
        highlightColour: null
      },
      resourceForm: {},
      submitting: false,
      resourceGroupLoading: true,
      resourceGroupList: [],
    }
  },
  created() {
    this.ResourceTypes = ResourceTypes
    this.ResourceTypeLookup = ResourceTypeLookup
  },
  mounted() {
    // Load list of resource groups
    this.resourceGroupLoading = true
    this.$apiService.tasksService.getResourceGroupList()
    .then(response => {
      this.resourceGroupList = response.data.map(group => {
        return {
          value: group.id,
          name: group.name,
          colour: group.highlightColour
        }
      })
    })
    .finally(() => {
      this.resourceGroupLoading = false
    })
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Resource' : 'Edit Resource'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
    isUserType() {
      return this.resourceData.type == ResourceTypes.user
    },
    stockUOMTypeOptions() {
      // Ignore certain UOM types not applicable to inventory
      var unavailableTypes = [UOMTypes.eachSubItem]
      return UOMTypeLookup.filter(lookup => !unavailableTypes.includes(lookup.value))
    },
  },
  methods: {
    show(resource) {
      // Reset form
      this.resourceData = {
        name: '',
        userId: null,
        type: ResourceTypes.general,
        resourceGroups: [],
      }
      this.resourceForm = {}
      this.submitting = false

      if(resource != null) {
        this.resourceData = _.cloneDeep(resource)
        this.resourceData.resourceGroups = []
        if(_.isArray(resource.resourceGroups))
          this.resourceData.resourceGroups = resource.resourceGroups.map(group => group.id)
      } else {
        if(this.$props.resourceGroupId)
          this.resourceData.resourceGroups.push(this.$props.resourceGroupId)
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true

      var resourceData = _.cloneDeep(this.$data.resourceData)
      if(!this.isUserType)
        resourceData.userId = undefined

      if(this.isCreateMode) {
        this.$apiService.tasksService.createResource(resourceData)
        .then(response => {
          this.submitting = false
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.resourceForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.tasksService.updateResource(resourceData.id, resourceData)
        .then(response => {
          this.submitting = false
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.resourceForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>